import Api from "@/services/Api";

export default {
    async getDepartments(vendor_id) {
        var departments = []
        await Api(true).post('department/list/' + vendor_id, {})
        .then(r => {
            departments = r.data
        })
        return departments
    },

    async getDepartmentsList() {
        var departments = []
        await Api(true).post('department/list', {})
        .then(r => {
            departments = r.data
        })
        return departments
    },

    async createDepartment(department, vendor_id) {
        const r = await Api(true).post('department/create/' + vendor_id, department)
        const data = r.data
        return Array.isArray(data) ? (data[0] ?? null) : data
    },

    async editDepartment(department, vendor_id) {
        const r = await Api(true).post('department/edit/' + vendor_id, department)
        const data = r.data
        return Array.isArray(data) ? (data[0] ?? null) : data
    }
};
